var $ = jQuery;
const ajax_url = ajax_path.url;
jQuery.datetimepicker.setLocale('ru');

$(document).ready(function () {

    Modernizr.on('webp', function (result) {
        if (!result) {
            $('.banners__banner-item, .banners__carousel-control, .services__heading, .certificates-carousel__carousel-control, .portfolio__carousel-control, .articles__carousel-control').addClass("safari-fallback");
        }
    });

    $('.banners__carousel').slick({
        fade: true,
        prevArrow: '<button class="banners__carousel-control banners__carousel-control--prev"></button>',
        nextArrow: '<button class="banners__carousel-control banners__carousel-control--next"></button>'
    })

    $('.header__toggler').click(function () {
        $(this).toggleClass('header__toggler--active');

        if ($(this).hasClass('header__toggler--active')) {
            $('.header__header-menu').css("display", "flex")
                .hide()
                .fadeIn();

        } else {
            $('.header__header-menu').fadeOut();
        }
    })

    if (window.matchMedia("(max-width: 767.98px)").matches) {

        var header = $(".header");
        var menu = $('.header__center-wrap');
        var header_height = header.height();

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= header_height) {
                menu.addClass('header__center-wrap--fixed')
            } else {
                menu.removeClass("header__center-wrap--fixed");
            }
        });

    }

    $('.team-list__link').click(function (e) {
        e.preventDefault();
        var target = $(this).data('person');
        $('.team-list__item--active').removeClass('team-list__item--active')
        $(this).parent().addClass('team-list__item--active');
        $('.team__person--active').removeClass('team__person--active');
        $(`.team__person[data-person="${target}"]`).addClass('team__person--active');

    })

    $('.services__certificates-carousel').slick({
        fade: true,
        prevArrow: '<button class="certificates-carousel__carousel-control certificates-carousel__carousel-control--prev"></button>',
        nextArrow: '<button class="certificates-carousel__carousel-control certificates-carousel__carousel-control--next"></button>'
    })

    $('.portfolio__carousel-wrap--photo').slick({
        fade: true,
        prevArrow: '.portfolio__carousel-control--prev-photo',
        nextArrow: '.portfolio__carousel-control--next-photo',
    })

    $('.portfolio__carousel-wrap--video').slick({
        fade: true,
        prevArrow: '.portfolio__carousel-control--prev-video',
        nextArrow: '.portfolio__carousel-control--next-video',
    })

    /*     $('.articles__carousel-wrap').slick({
            fade: true,
            prevArrow: '.articles__carousel-control--prev',
            nextArrow: '.articles__carousel-control--next',
        }) */



    $('.filter__toggle').click(function (e) {
        e.stopPropagation();
        $(this).toggleClass('filter__toggle--expanded');
        $(this).parent().find('.filter__dropdown').toggle();
    })

    $(document).click(function (e) {
        if (!$(e.target).is('.filter__dropdown, .filter__dropdown *')) {
            $(".filter__dropdown").hide();
            $('.filter__toggle').removeClass('filter__toggle--expanded');
        }
    });

    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $('.product__carousel--full').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product__carousel--nav'
    })

    $('.product__carousel--nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.product__carousel--full',
        focusOnSelect: true,
        arrows: false,
    });

    $('#orderby').change(function () {
        $(this).closest('form').submit();
    })

    $('[name="ticket_value"]').change(function () {
        var value = $(this).val();

        if (value == 'other') {
            var value = 0;
            $('[name="ticket_value_custom"]').keyup(function () {
                var value = $('[name="ticket_value_custom"]').val();
                var discount = value / 100 * 10;
                var price = value - discount;
                $('.form__old-price').text(value + ' руб.')
                $('.form__new-price').text(price + ' руб.')
            });
        } else {
            var discount = value / 100 * 10;
            var price = value - discount;
            $('.form__old-price').text(value + ' руб.')
            $('.form__new-price').text(price + ' руб.')
        }

    })

    $('[name="cert_value"]').change(function () {
        var value = $(this).val();
        $('.form__price div').text(value + ' руб.')
    })

    $('#popup-product').on('show.bs.modal', function (event) {
        var id = $(event.relatedTarget).data('product_id');
        var data = `product_id=${id}&action=product_modal`;
        $.ajax({
            url: ajax_url,
            type: 'post',
            data: data,
            success: function (result) {
                $('#popup-product .modal__product').empty();
                $('#popup-product .modal__product').html(result);
                setTimeout(function () {
                    $('.product__carousel--full').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: '.product__carousel--nav'
                    })

                    $('.product__carousel--nav').slick({
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        asNavFor: '.product__carousel--full',
                        focusOnSelect: true,
                        arrows: false,
                    });
                    $('.product__carousel--full').slick('refresh');
                    $('.product__carousel--nav').slick('refresh');
                }, 100);
            },
        });
    });


    $(document).on('click', '.balloon__link', function (e) {
        e.preventDefault();
        var img = $(this).data('img');
        var text = $(this).data('text');
        var modal = $('.how-to-reach');

        modal.find('.how-to-reach__img').attr('src', img);
        modal.find('.how-to-reach__description').text(text);
        modal.css("display", "flex")
            .hide()
            .fadeIn();
    });

    $('.how-to-reach').click(function () {
        $(this).fadeOut();
    })

    $('.form__btn--reset').click(function () {
        var parent = $(this).parent();
        parent.find('input[type="checkbox"]').attr('checked', false);
    })

    $('[data-click="book"]').click(function (e) {
        e.preventDefault();
        showSonlineWidget({
            groupid: 63
        })
    })






    const addresses = barbershops.addresses;
    ymaps.ready(init);

    function init() {
        // Создание карты.
        var Map = new ymaps.Map("map", {
            //center: [55.752617, 37.601494], //latitude-широта, longitude-долгота
            center: [55.759393, 37.601837], //latitude-широта, longitude-долгота
            zoom: 10,
            controls: []
        });
        Map.behaviors.disable("scrollZoom");
        Map.controls.add("zoomControl", {
            size: "small",
            position: {
                bottom: 40,
                right: 20
            }
        });


        var tags = [];
        addresses.forEach((element) => {
            tags.push(new ymaps.Placemark(
                [element.longitude, element.latitude], {
                    clusterCaption: element.name,
                    balloonContentHeader: '<div class="balloon__title">' + element.name + '<div class="balloon__subtitle">Как добраться</div></div>',
                    balloonContent: '<div class="balloon__address">' + element.address + '</div><div class="balloon__links"><a href="#" data-img="' + element.scheme_metro_img + '" data-text="' + element.scheme_metro + '" class="balloon__link"><img width="50" height="40" src="http://shuvalov.crazytest.studio/alyaska/wp-content/themes/alyaska/assets/img/icons/metro-sign.png" alt="" /></a><a href="#" data-img="' + element.scheme_car_img + '" data-text="' + element.scheme_car + '" class="balloon__link"><img width="56" height="40" src="http://shuvalov.crazytest.studio/alyaska/wp-content/themes/alyaska/assets/img/icons/car-sign.png" alt="" /></a></div>'
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: 'http://shuvalov.crazytest.studio/alyaska/wp-content/themes/alyaska/assets/img/icons/location-alt.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }))
        })

        var points = ymaps.geoQuery(tags).addToMap(Map);

        $('.shops-list__item--map').click(function () {
            var coords = $(this).data('coords');
            points.getClosestTo(coords).balloon.open();
        })

    }

    $(document).on('click', '.product-item__btn', function (a) {
        a.preventDefault();

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: $(this).data('product_id'),
            product_sku: '',
            quantity: $(this).data('quantity'),
            variation_id: 0,
        };

        $.ajax({
            type: 'post',
            url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
            data: data,
            beforeSend: function (response) {
                $(this).removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $(this).addClass('added').removeClass('loading');
            },
            success: function (response) {
                var fragment = response.fragments['a.cart-contents'];
                var count = parseInt($(fragment).find('.count').text());
                $('.header__cart-count').text(count);
                $('.add-to-cart-notice').css({
                    top: 0
                })

                setTimeout(() => {
                    $('.add-to-cart-notice').css({
                        top: -100
                    })
                }, 2000);
            },

        });

    })

    $(document).on('click', '.modal .product__btn', function (a) {
        a.preventDefault();

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: $(this).data('product_id'),
            product_sku: '',
            quantity: $(this).data('quantity'),
            variation_id: 0,
        };

        $.ajax({
            type: 'post',
            url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
            data: data,
            beforeSend: function (response) {
                $(this).removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $(this).addClass('added').removeClass('loading');
            },
            success: function (response) {
                var fragment = response.fragments['a.cart-contents'];
                var count = parseInt($(fragment).find('.count').text());
                $('.header__cart-count').text(count);
                $('.add-to-cart-notice').css({
                    top: 0
                })

                setTimeout(() => {
                    $('.add-to-cart-notice').css({
                        top: -100
                    })
                }, 2000);
            },

        });

    })

    $('.form__control--date').datetimepicker();


})